import React from 'react';
import TransferCoins from './TransferCoins';
import BuyCoins from './BuyCoins';

export default class CoinsPage extends React.Component {
  render () {
    return (
      <div className="c-transfer-coins-page">
        <h1>Transfer coins</h1>
        <div className="c-components">
          <TransferCoins/>
          <BuyCoins/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CoinsPage/CoinsPage.js